module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-07-91ce6b9a3fc11b48f125ed0dece9ebab.png";